import { Component } from '@angular/core';

@Component({
    selector: 'no-content',
    templateUrl: './no-content.html',
    standalone: false
})
export class NoContent {

}
